export default "__VITE_ASSET__15dcc976__"